'use client';

import { useEffect, useRef } from 'react';

const VIDEO_URL =
  'https://umhlxynfxtzfvtvdxwlb.supabase.co/storage/v1/object/public/East%20Coast%20Hero%20video/EastCoast%20Final%20Website%20(1)%20(1).mp4';

export default function HeroCarousel() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef?.current;
    if (!video) return;
    video.muted = true;
    video?.setAttribute('playsinline', '');
    video?.setAttribute('webkit-playsinline', '');
    const playPromise = video?.play();
    if (playPromise !== undefined) {
      playPromise?.catch(() => {
        // Autoplay was prevented — video stays paused
      });
    }
  }, []);

  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <style>{`
        video::-webkit-media-controls {
          display: none !important;
        }
        video::-webkit-media-controls-enclosure {
          display: none !important;
        }
        video::-webkit-media-controls-panel {
          display: none !important;
        }
        video::-webkit-media-controls-play-button {
          display: none !important;
        }
        video::-webkit-media-controls-start-playback-button {
          display: none !important;
        }
        video::--webkit-media-controls-overlay-play-button {
          display: none !important;
        }
      `}</style>
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        disablePictureInPicture
        disableRemotePlayback
        x-webkit-airplay="deny"
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '177.78vh',
          minWidth: '100%',
          height: '56.25vw',
          minHeight: '100%',
          transform: 'translate(-50%, -50%)',
          objectFit: 'cover',
          WebkitMaskImage: '-webkit-radial-gradient(white, black)',
        }}
      >
        <source src={VIDEO_URL} type="video/mp4" />
      </video>
      {/* Dark overlay for text readability */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(180, 180, 180, 0.25)',
        }}
      />
    </div>
  );
}